module.exports = __webpack_public_path__ + "static/media/weronika_d.f96618c5.jpg";